import React, { type FC, type PropsWithChildren } from 'react';

import Box from '../../box/box';

export type CardDividerProps = {
  /** Determines whether divider will be contained, or bleed the full width of the card */
  type?: 'default' | 'defaultPrimary' | 'fullBleed' | 'fullBleedPrimary' | 'none';
};

const CardDivider: FC<PropsWithChildren<CardDividerProps>> = ({ type }) => (
  <Box
    css={theme => [
      {
        label: 'cardDivider',
        height: 0,
        borderBottom: `1px solid ${type?.match(/primary/gi) ? theme.colors.primary : theme.colors.coolGrey[20]}`,
      },
      type?.includes('fullBleed') && {
        width: 'calc(100% + 48px)',
        alignSelf: 'center',
      },
    ]}
    data-card-element="divider"
    data-testid="card-divider"
  />
);

export { CardDivider };
export default CardDivider;
